import { Box, Card, Grid } from '@mui/material';
import { BsFillPersonFill } from 'react-icons/bs';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsIconText,
  WsButton,
  timeSince,
  WsIconViewJD,
} from 'wisestep-base';

import PulseIconText from '../../../../components/PulseIconText';
import { getBotCandidateDetails } from '../utils/CareerBuilderHelper';

const DiceBotDownloadMatchCard = ({ candidate, createdOn, onViewCvClick, candidateId }) => {
  const candidateData = candidate.ResumeResultItem_V3;

  return (
    <Grid p={1.5}>
      <Card>
        <Box px={2} py={1}>
          <Grid container item xs={12} alignItems="center">
            <Grid item xs={8} pl={1}>
              <Grid container item xs={12} columnGap={0.5}>
                <Box pt={0.4} px={0.5}>
                  <BsFillPersonFill color={WsColors.TheBlues500} size={22} />
                </Box>
                <Box pt={0.2}>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.BLACK}
                    cursor="pointer"
                  >
                    {candidateData.ContactName ?? ''}
                  </WsTypography>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <PulseIconText
              text={`Resume  Updated ${timeSince(
                String(candidateData.LastUpdate)
              )} * Harvested  ${timeSince(String(createdOn))} * Active  ${timeSince(
                String(candidateData.LastActivity)
              )}`}
            />
          </Grid>

          <Grid container item xs={12} pl={1} py={1} spacing={1}>
            {getBotCandidateDetails(candidateData)?.map((detailsObj, index) => (
              <Grid item xs={4} key={index}>
                <WsIconText
                  icon={detailsObj.icon ?? <></>}
                  text={detailsObj.labelName ?? ''}
                  opacity={true}
                  popOverText={`${detailsObj.popOverText}`}
                  textCursor="pointer"
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box sx={{ backgroundColor: WsColors.TheBlues25 }} p={1.5}>
          <Grid display="flex" flex-direction="row-reverse" container>
            <Grid item container justifyContent="flex-end" spacing={2}>
              <WsButton
                variant="contained"
                size="large"
                startIcon={<WsIconViewJD color={WsColors.White} />}
                onClick={() => onViewCvClick(candidateId)}
              >
                View CV
              </WsButton>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Grid>
  );
};

export default DiceBotDownloadMatchCard;
